
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's1488e73779d7682f': `1) Öffnen Sie das Menü Ihres Browsers`,
's182ab2d6c997515f': `Fügen Sie es zu Ihrem Startbildschirm hinzu, um eine umfassende Erfahrung und einen leichten Zugriff zu erhalten.`,
's1b9047d53d9f9d22': `2) Drücken Sie auf Teilen in der Navigationsleiste`,
's2d90afa5dcca2c0e': `3) Scrollen Sie nach unten zu "Zum Startbildschirm hinzufügen"`,
's37a9e8aec5713460': `Mehr`,
's4593f304dac8848c': `2) Tippen Sie auf "Zum Startbildschirm hinzufügen"`,
's54cfbb14f46396d4': `1) Öffnen Sie es in Ihrem Hauptbrowser`,
's6196153c4b0c1ea0': `Installieren`,
's922329d6f6213590': `Zum Dock hinzufügen`,
'sa5ef80b4bb9b39f8': `Weniger`,
'sa7551383d1897fcc': `2) Drücken Sie auf Zum Dock hinzufügen`,
'sba52286c21552a4e': `Installieren Sie es auf Ihrem Gerät für eine umfassende Erfahrung und einen leichten Zugriff.`,
'sc79fd7641eb9a975': `Anleitung ausblenden`,
'scdaf4bbff76674c8': `Hinzufügen zum Startbildschirm`,
'se740f75b95a51807': `Fügen Sie es zu Ihrem Dock hinzu, um eine umfassende Erfahrung und einen leichten Zugriff zu erhalten.`,
'sfea652f6580ff086': `Diese Website verfügt über App-Funktionalität.`,
    };
  